<template>
    <slot v-bind="{
        ...state,
        categories,
        loadMore,
        setCategory,
    }" />
</template>

<script setup>
import { stringify } from 'qs-esm';
import { computed, onBeforeMount, reactive } from 'vue';

const props = defineProps({
    blogId: {
        type: String,
    },
    categories: {
        type: Array,
        default: [],
    },
    tags: {
        type: Array,
        default: [],
    },
});

const postsPerPage = 18;

const state = reactive({
    hasInitialized: false,
    isLoading: true,
    isProcessing: false,
    posts: [],
    category: null,
    tag: null,
    title: null,
    page: 1,
    hasMore: false,
});

const applySearchParams = () => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has('category')) {
        state.category = searchParams.get('category');
    } else if (searchParams.has('tag')) {
        state.tag = searchParams.get('tag');
    }

    // processResults();
}

const updateSearchParams = () => {
    const searchParams = new URLSearchParams();

    if (state.category) {
        searchParams.set('category', state.category);
    }

    const url = new URL(window.location);

    url.search = searchParams.toString();

    window.history.pushState(null, '', url.toString());
}

const categories = computed(() => {
    return props.categories.filter(category => {
        return category.count > 0;
    });
});

const getPosts = async () => {
    const params = {
        blogId: props.blogId,
        page: state.page,
        limit: postsPerPage,
        attributeWhere: {
            'custom.hide_in_blog': {
                not_equals: true,
            },
        },
    }

    if (state.category) {
        params.categoryId = props.categories.find(category => category.slug === state.category)?.id;
    } else if (state.tag) {
        params.tagId = props.tags.find(tag => tag.slug === state.tag)?.id;
    }

    const stringifiedQuery = stringify(params, { addQueryPrefix: true });

    const { docs, hasNextPage } = await fetch(`/api/posts${stringifiedQuery}`).then(response => { // eslint-disable-line
        return response.json();
    });

    for (const doc of docs) {
        doc.categories = doc.categories || [];

        state.posts.push(doc);
    }

    if (state.page === 1) {
        if (state.category) {
            state.title = props.categories.find(category => category.slug === state.category)?.title;
        } else if (state.tag) {
            state.title = props.tags.find(tag => tag.slug === state.tag)?.title;
        }
    }

    state.hasMore = hasNextPage;
}

const setCategory = event => {
    if (event.target.value !== state.category) {
        state.category = event.target.value;

        updateSearchParams();
        reset();
    }
}

const reset = () => {
    state.isLoading = true;
    state.posts = [];
    state.page = 1;
    state.hasMore = false;
    state.title = null;

    return getPosts().finally(() => {
        state.isLoading = false;
    });
}

const loadMore = async () => {
    state.page = state.page + 1;
    state.isProcessing = true;

    getPosts().finally(() => {
        state.isProcessing = false;
    });
}

onBeforeMount(async () => {
    applySearchParams();

    reset().finally(() => {
        state.hasInitialized = true;
    });
});
</script>
